import React, { useState } from "react";

import Step from "components/MainApp/atoms/Wizard/Step";
import Icon from "components/MainApp/atoms/Icon/icon";
import InputText from "components/MainApp/atoms/Forms/MainInput";
import Item from "components/MainApp/organisms/Tags/Tag";
import DeviceSelector from "components/Functionals/DeviceSelector";

import styles from "./Step1.module.scss";
import i18n from "i18n";
import TagReadInput from "shared/components/Input/TagReadInput";

export const ThirdPartyTagAssociationStepOne = ({
  enabledRead,
  typeRead,
  refRead,
  associateRead,
  priorityRead,
  receiveEvent,
  readTags,
  selectedTags,
  searchValue,
  handleSearch,
  goBackFunc,
  handleDelete,
  handleDeleteAll,
  handleSend,
}) => {
  const [searchedValue, setSearchedValue] = useState("");
  const [inputError, setInputError] = useState("");

  const handleFilteredInput = (e) => {
    const value = e.target.value;
    setSearchedValue(value);

    const isHex = /^[0-9a-fA-F]*$/.test(value); // permite vacío también
    if (!isHex) {
      setInputError(i18n.t("hexa.number.error"));
    } else {
      setInputError("");
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const isHex = /^[0-9a-fA-F]+$/.test(searchedValue);
    if (!isHex) {
      setInputError(i18n.t("hexa.number.error"));
      return;
    }
    setInputError("");
    if (handleSearch) {
      handleSearch(e, searchedValue);
      setSearchedValue("");
    }
  };

  const stepContent = (
    <div className={styles["associate-tags-step-one-content"]}>
      <DeviceSelector
        enabled={enabledRead}
        typeRead={typeRead}
        refRead={refRead}
        associateRead={associateRead}
        priorityRead={priorityRead}
        receiveEvent={receiveEvent}
        includeType={"MOB_READER|LIFT|FITTING"}
      />
      <div
        className={styles["associate-tags-step-one-field"]}
        data-automation-id="input-search"
      >
        <div className={styles["input-with-error"]}>
        <TagReadInput searchValue={handleFilteredInput} searchedValue={searchedValue} handleSubmit={handleSubmit} error={!!inputError} />
        <div className={styles["input-error"]} style={{ minHeight: 18 }}>
          {inputError || "\u00A0"}
        </div>
        </div>
        <div className={styles["load-movement-items-count"]}>{readTags.length}</div>
        <div className={styles["load-movement-items-list"]}>
          {readTags &&
            readTags.map((tag) => {
              return (
                <Item
                  tag={tag}
                  handleDelete={handleDelete}
                  handleSelect={null}
                  selected={false}
                  type={null}
                  message={''}
                />
              );
            })}
        </div>
      </div>
    </div>
  );
  return (
    <div className={styles["associate-tags-step-one-container"]}>
      <Step content={stepContent}></Step>
    </div>
  );
};

export default ThirdPartyTagAssociationStepOne;
